import React from 'react';
import { StyledNav } from './nav-tabs.style';
import { theme } from '../../../style/global-style';
import { Tabs, Tab, ButtonBase } from '@mui/material';
import { DeviceContext } from '../../../contexts/device/device';
import { Arrow } from '../../atoms/arrow/arrow';

export interface ITab {
    key: string;
    title: string;
}

export interface INavTabs {
    title: string;
    tabs: ITab[];
    onSelect: (tab: number) => void;
    currentTabIndex?: number;
}

export const NavTabs = (props: INavTabs) => {
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);
    const device = React.useContext(DeviceContext);

    const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
        props.onSelect(newValue);
    };

    React.useEffect(() => {
        setCurrentTabIndex(props.currentTabIndex || 0);
    }, [props.currentTabIndex]);

    return (
        <StyledNav data-testid="nav-tabs" active={currentTabIndex}>
            <Tabs
                variant={device === 'desktop' ? `standard` : `scrollable`}
                value={currentTabIndex}
                onChange={handleChange}
                aria-label={`nav tabs`}
                className={`nav-tabs`}
                classes={{
                    indicator: `nav-tabs-indicator`,
                }}
                scrollButtons={true}
                ScrollButtonComponent={({
                    classes,
                    className: classNameProp,
                    direction,
                    orientation,
                    visible,
                    ...other
                }) => {
                    return (
                        <ButtonBase component="div" className={classNameProp} {...other}>
                            {direction === 'left' ? (
                                <Arrow
                                    size="M"
                                    orientation="left"
                                    style={{
                                        margin: '0 2px',
                                        opacity: visible ? 1 : 0.5,
                                        fill: '#fff',
                                    }}
                                />
                            ) : (
                                <Arrow
                                    size="M"
                                    orientation="right"
                                    style={{
                                        margin: '0 2px',
                                        opacity: visible ? 1 : 0.5,
                                        fill: '#fff',
                                    }}
                                />
                            )}
                        </ButtonBase>
                    );
                }}
                style={{
                    backgroundColor: theme.colors.main2,
                    color: theme.shades.white,
                    minHeight: device === 'mobile' ? 50 : 40,
                }}
            >
                {props.tabs.map((tab) => (
                    <Tab
                        key={tab.key}
                        component={`a`}
                        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                            // @TODO remove this for navigating
                            event.preventDefault();
                        }}
                        className={`nav-tabs-tab`}
                        classes={{ selected: `nav-bar-active` }}
                        label={tab.title}
                        style={{
                            minHeight: device === 'mobile' ? 50 : 40,
                            fontSize: 14,
                            color: theme.shades.white,
                        }}
                        disableTouchRipple={device === 'mobile'}
                    />
                ))}
            </Tabs>
        </StyledNav>
    );
};
